{
  "contractVersion": 1,
  "generatedAt": "2026-11-01T00:00:00.000Z",
  "season": { "id": "season-2026-q4", "name": "Season 4", "dayNumber": 15 },
  "sides": {
    "beornings": { "totalPoints": 49750, "sharePct": 99.0 },
    "lothwen": { "totalPoints": 502.53, "sharePct": 1.0 }
  },
  "world": { "treesChoppedTotal": 497, "treesPlantedTotal": 5 },
  "events": [
    { "id": 501, "type": "tree_felled", "side": "beornings", "at": "2026-10-30" },
    { "id": 502, "type": "tree_felled", "side": "beornings", "at": "2026-10-31" },
    { "id": 503, "type": "tree_felled", "side": "beornings", "at": "2026-10-31" },
    { "id": 504, "type": "tree_planted", "side": "lothwen", "at": "2026-11-01" }
  ]
}
